import React, { Component } from 'react'
import FixedView from '../../components/FixedView'
import FormViewer from '../../components/FormViewer'
import SidebarView from '../../components/SidebarView'
import { translate } from '../../utils/useful'



export default class NewOtherAccount extends Component {
    state = {
        Accounts: [
            { title: "Outlook", icon: "/assets/icons/email/outlook.png" },
            { title: "microsoft", icon: "/assets/icons/email/microsoft.png" },
            { title: "Google", icon: "/assets/icons/email/google.png" },
            { title: "Yahoo", icon: "/assets/icons/email/yahoo.png" },
            // {title:"Yahoo",icon:"/assets/icons/email/yahoo.png"},
            // {title:"Yahoo",icon:"/assets/icons/email/yahoo.png"},
            // {title:"Yahoo",icon:"/assets/icons/email/yahoo.png"},
            { title: "iCloud", icon: "/assets/icons/email/icloud.png" },
        ],

        headers: {
            other: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
                { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
                { key: 'password', type: 'PasswordInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}*********', required: true, }, showMain: false },
                { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },
            ],
            outlook: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
                { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
                { key: 'password', type: 'PasswordInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}*********', required: true, }, showMain: false },
                { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },
            ],
            google: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
                { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
                { key: 'password', type: 'PasswordInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}*********', required: true, }, showMain: false },
                { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },
            ],
            yahoo: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
                { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
                { key: 'password', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}*********', required: true, }, showMain: false },
                { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },
            ],
            iCloud: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
                { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
                { key: 'password', type: 'PasswordInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}*********', required: true, }, showMain: false },
                { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },
            ],
        }
    }



    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    submitForm = () => {
        let data = this.form.getForm()
        if (data) {
            this.props.setData('data', data, () => {
                this.props.changeStage("second")
            })
        }
    }

    render() {
        return (
            <div className='h-100 scroll-no-scrollbar'>
                <div className='p-3 flexcb' style={{ borderBottom: "1px solid #ddd" }}>
                    <p className='font-size-18 weight-500'>{translate('mail.New Account')}</p>
                    <button className='blue-btn br-10 px-3 py-2' onClick={() => this.submitForm()}>
                        <p className='white font-size-14'>{translate('mail.Next')}</p>
                    </button>
                </div>
                <div className='mt-3'>
                    <FormViewer ref={el => this.form = el} initData={this.props.data} headers={this.state.headers[this.props.currentTab]} inputClass={"modern-input"} />
                </div>
            </div>
        )
    }
}
